'use client';

import Pagination, {
  Carousel,
  CarouselContent,
  CarouselItem,
  useCarouselControls,
} from '@/components/ui/carousel';
import { EventDataType } from '@/types/EventDataType.type';
import React, { use } from 'react';
import { Skeleton } from '@/components/ui';
import { SliderCarouselItem } from './components';

interface SliderCarouselProps {
  sliderEventsData: Promise<EventDataType[]> | null;
}

export default function SliderCarousel({
  sliderEventsData,
}: SliderCarouselProps): React.ReactNode {
  const eventsData = sliderEventsData ? use(sliderEventsData) : null;

  const { currentSlide, totalSlides, handlePageChange, setCarouselApi } =
    useCarouselControls({ autoplay: true });

  return (
    <Carousel className='mt-9 sm:mt-0' opts={{ loop: true, align: 'center' }} setApi={setCarouselApi}>
      <CarouselContent className='px-0 sm:h-[18rem] sm:pt-5 sm:pr-0 md:h-[20rem] xl:h-[20rem] '>
        {eventsData
          ? eventsData.map((event, index: number) => (
              <SliderCarouselItem {...event} key={index} />
            ))
          : Array.from({ length: 5 }).map((_, index) => (
              <CarouselItem
                key={`HERO_SLD_SKT_${index}`}
                className='basis-full sm:basis-1/2 sm:last:pr-4'
              >
                <Skeleton className='h-full w-full sm:rounded-md' />
              </CarouselItem>
            ))}
      </CarouselContent>
      <Pagination
        currentPage={currentSlide}
        onPageChange={handlePageChange}
        totalPages={eventsData ? totalSlides : 5}
        duration={3000}
      />
    </Carousel>
  );
}
